module.exports = __webpack_public_path__ + "img/frame (99).86a84487.jpg";